<template lang="pug">
div.profile-container( v-if="userInfo" )
  span.text-20-b Личные данные
  v-text-field.mt-2.text-16(
    v-model="userInfo.fio"
    label="ФИО"
    outlined
    dense
    height="58"
    style="border-radius: 12px !important;"
    readonly
  )
  v-text-field.text-16(
    v-model="returnYearOfBirth"
    label="Дата рождения"
    outlined
    dense
    height="58"
    style="border-radius: 12px !important;"
    readonly
  )

  v-text-field.text-16(
    v-model="userInfo.email"
    label="Электронная почта"
    outlined
    dense
    height="58"
    style="border-radius: 12px !important;"
    @blur="updateInfo('email', userInfo.email)"
  )
    template( v-slot:append )
      img.icon( src="@/assets/profile/pencil.svg" )
  
  v-text-field.text-16(
    :value="formattedPhone"
    label="Телефон для экстренной связи"
    outlined
    dense
    height="58"
    style="border-radius: 12px !important;"
    maxlength="18"
    @input="onPhoneInput"
    @paste="onPhonePaste"
    @blur="updateInfo('other_phone', userInfo.other_phone)"
  )
    template( v-slot:append )
      img.icon( src="@/assets/profile/profile-icon.svg" @click="openPhoneBook" )

  div.button-exit( @click="logout" )
    span.text-16-b Выйти
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ProfilePage',

  data() {
    return {
      fio: "Иванов Иван Иванович",
      birthday: "03.12.2014",
      phoneNumber: "+7-981-000-00-00"
    }
  },

  computed: {
    ...mapState('user', ['userInfo']),

    returnYearOfBirth() {
      let date = this.userInfo.birth_date.split(' ')[0].split('-').reverse().join('.');
      return date
    },

    formattedPhone() {
      return this.formatPhone(this.userInfo.other_phone);
    },
  },

  methods: {
    ...mapActions('user', ['loadUserInfo', 'loadCard', 'changeProfileInfo']),
    ...mapActions('auth', ['loadLogOut']),

    openPhoneBook() {
      this.hijackingPhoneNumber()
      let devicePlatform = this.returnPlatformDevice()
      if(devicePlatform == 'iPhone') {
        window.location.hash = "#" + "phone";
      }

    },
    formatPhone(value) {
      if (!value) return '';
      let digits = value.replace(/\D/g, '').slice(0, 11);
      let result = '+7';
      if (digits.length > 1) result += ` (${digits.slice(1, 4)}`;
      if (digits.length >= 4) result += `) ${digits.slice(4, 7)}`;
      if (digits.length >= 7) result += `-${digits.slice(7, 9)}`;
      if (digits.length >= 9) result += `-${digits.slice(9, 11)}`;

      return result;
    },

    onPhoneInput(event) {
      const raw = event.replace(/\D/g, '');
      this.userInfo.other_phone = raw;  
    },

    onPhonePaste(e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '');
      this.userInfo.other_phone = pasted.slice(0, 11);
    },
    
    logout() {
      let devicePlatform = this.returnPlatformDevice()
      if(devicePlatform != "iPhone") {
        this.loadLogOut().then(() => {
          this.$router.push('/auth')
        })
        return
      }   
      
      if(devicePlatform == 'iPhone') {
        this.loadLogOut().then(() => {
          window.location.href = "#logout"
        })
      }
    },

    updateInfo(fieldName, value) {
      if(fieldName == "other_phone") value = value.replace(/\D/g, '')
      let obj = {type: fieldName, value: value, profileUuid: this.userInfo.uuid}
      this.changeProfileInfo(obj)
      
    }
  }
}
</script>
<style scoped>
.rounded-input .v-input__control {
  border-radius: 12px !important;
}
.profile-container {
  padding: 42px 26px 0px 26px;
  height: 100%;
  width: 100%;
}
.icon {
  margin-top: 10px;
}
.button-exit {
  margin-top: 56px;
  height: 60px;
  border-width: 2px;
  border-radius: 16px;
  border: 2px dashed #BFDBFE;
  background: #EFF6FF;
  color: #5365E5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
